/**
 * Breadcrumb del prodotto in base alla pagina di provenienza.
 *
 * Il server rende Home > Prodotti > Brand > Prodotto e mette sul nav
 * (data-celada-origins) le altre pagine da cui si può arrivare al prodotto:
 * tecnologie e settori (vedi inc/breadcrumbs.php). Se il referrer è una di
 * queste, quella pagina prende il posto del brand (data-celada-brand):
 * Home > Prodotti > {provenienza} > Prodotto.
 */
function normalizeUrl( url ) {
	try {
		const parsed = new URL( url, window.location.origin );
		return parsed.origin + parsed.pathname.replace( /\/?$/, '/' );
	} catch ( e ) {
		return '';
	}
}

export function initBreadcrumbOrigin() {
	const nav = document.querySelector( 'nav.wp-block-breadcrumbs[data-celada-origins]' );
	if ( ! nav || ! document.referrer ) return;

	let origins;
	try {
		origins = JSON.parse( nav.dataset.celadaOrigins );
	} catch ( e ) {
		return;
	}

	const referrer = normalizeUrl( document.referrer );
	const origin   = origins.find( ( item ) => normalizeUrl( item.url ) === referrer );
	const current  = nav.querySelector( 'li:last-child' );
	if ( ! origin || ! current ) return;

	const li   = document.createElement( 'li' );
	const link = document.createElement( 'a' );
	link.href        = origin.url;
	link.textContent = origin.label;
	li.appendChild( link );

	const brandUrl  = nav.dataset.celadaBrand ? normalizeUrl( nav.dataset.celadaBrand ) : '';
	const brandLink = brandUrl
		? Array.from( nav.querySelectorAll( 'li > a' ) ).find( ( a ) => normalizeUrl( a.href ) === brandUrl )
		: null;

	if ( brandLink ) {
		brandLink.parentNode.replaceWith( li );
	} else {
		current.parentNode.insertBefore( li, current );
	}
}
